export default {
  componentName: 'EstablishmentTypeFilter',
  fr: {
    label: 'Établissements',
    all: 'Tous les établissements',
    placeholder: 'Tous',
    withPharmacy: 'Pharmacie',
    withPrivateClinic: 'Clinique',
    withHealthEstablishment: 'Public',
    others: 'autres',
    ariaLabel:
      "Filtrer par type d'établissements. Liste déroulante, {1} sur {2}. Option {0} sélectionnée. Pour changer la sélection, appuyez sur entrer, puis utilisez flèche haut et bas. Appuyez sur entrer pour confirmer la sélection.",
    ariaLabelMobile:
      "Filtrer par type d'établissements. Groupe de boutons radio {1} sur {2}. Option {0} sélectionnée. Utilisez bas et haut pour naviguer.",
    itemOnly: '{0} seulement',
    ariaLabelItemSelected: '{0}. Sélectionné. Option {1} sur {2}',
    ariaLabelItemUnselected: '{0}. Non sélectionné. Option {1} sur {2}',
    optionsDescription: 'Liste déroulante de 4 options, ouverte.',
    optionsDescriptionMobile: '4 boutons radio.'
  },
  en: {
    label: 'Establishment',
    all: 'All establishments',
    placeholder: 'All',
    withPharmacy: 'Pharmacy',
    withPrivateClinic: 'Clinic',
    withHealthEstablishment: 'Public',
    others: 'others',
    ariaLabel:
      'Filter by establishment type. Combobox closed, {1} of {2}. Option {0} selected. To change the selection, press Enter, then use the up or down arrow. Press Enter to confirm the selection.',
    ariaLabelMobile:
      'Filter by establishment type. Radio buttons group, {1} of {2}. Option {0} selected. Use the flèche down or up to navigate.',
    itemOnly: '{0} only',
    ariaLabelItemSelected: '{0}. Selected. Option {1} of {2}',
    ariaLabelItemUnselected: '{0}. Not selected. Option {1} of {2}',
    optionsDescription: 'Combobox of 4 options, open.',
    optionsDescriptionMobile: '4 radio buttons.'
  }
}
